<template>
  <div class="pa-2">
    <EpiSuiteCard
      v-for="(card, i) in cards"
      :item="card"
      :key="i"
      :elevation="props.cardElevation"
      class="mb-6"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  logKow,
  mpbp,
  wsKow,
  waterNt,
  vp,
  hlc,
  logKoa,
  biowin,
  bioHcWin,
  logKoc,
  atmosphericHalfLife,
  bcfBaf,
  wvolWin,
  hydroWin,
  dermWin,
  aeroWin,
  stpWin,
  fugacity,
  ecosar,
} from './EpiSuiteCard/mappers'
import EpiSuiteCard from './EpiSuiteCard/EpiSuiteCard.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  cardElevation: {
    type: Number,
    default: 0,
  },
})

const cards = computed(() => [
  logKow(props.items),
  mpbp(props.items),
  wsKow(props.items),
  waterNt(props.items),
  vp(props.items),
  hlc(props.items),
  logKoa(props.items),
  biowin(props.items),
  bioHcWin(props.items),
  logKoc(props.items),
  atmosphericHalfLife(props.items),
  bcfBaf(props.items),
  wvolWin(props.items),
  hydroWin(props.items),
  dermWin(props.items),
  aeroWin(props.items),
  stpWin(props.items),
  fugacity(props.items),
  ecosar(props.items),
])
</script>
